import React from 'react';

const Referral = () => {
  return (
    <div className='referral-wrapper'>
      <div className='referral-name'>
        Now Refer & Earn ₹500 for every referral*
      </div>
      <div className='referral-terms'>
        *Terms and conditions will be applied
      </div>
    </div>
  );
};

export default Referral;
